import Http from './../http';

const prefix = '/power-ups';

export const create = (settings, id) => Http.authApi().post(`${prefix}`, { settings, id });
export const store = (settings, id) => Http.authApi().post(`${prefix}`, { settings, id });

export const update = header => {
  return Http.authApi().put(`${prefix}/${header.encrypted_id}`, header);
};

export const destroy = header => {
  return Http.authApi().delete(`${prefix}/${header.encrypted_id}`, header);
};

export const get = id => {
  return Http.authApi().get(`${prefix}/${id}`);
};

export const duplicate = item => {
  return Http.authApi().post(`/duplicate${prefix}/${item.encrypted_id}`);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/powerups.js